var map = {
	"./alper-logo-menu.png": "0c47",
	"./alper-logo.png": "abb6",
	"./casas-bahia-logo-menu.png": "d53d",
	"./casas-bahia-logo.png": "bb7b",
	"./login-bg.jpg": "3428",
	"./unifisa-logo-menu.png": "f5ab",
	"./unifisa-logo.png": "fa9c",
	"./unifisa-parceiros-logo-menu.png": "b3aa",
	"./unifisa-parceiros-logo.png": "12e3",
	"./user_logo.png": "379d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";